export const maskline = {
  // Core / neutrals
  crust: '#0d0d0d', // deepest background — pure blackened gray
  mantle: '#161616', // secondary background
  base: '#1f1f1f', // main background
  surface0: '#272727', // cards, modals
  surface1: '#2f2f2f', // hover / raised surfaces
  surface2: '#3a3a3a', // active / focus surfaces
  overlay0: '#444444', // border / low-contrast text
  overlay1: '#5a5a5a', // muted text / subtle accents
  overlay2: '#777777', // midtone text / subtle icons
  subtext0: '#9a9a9a', // secondary text
  subtext1: '#bcbcbc', // body text
  text: '#e4e4e4', // primary text, bright gray
  
  // Accents — all unified to match mauve
  lavender: '#9a9a9a',
  blue: '#9a9a9a',
  sapphire: '#9a9a9a',
  sky: '#9a9a9a',
  teal: '#9a9a9a',
  green: '#9a9a9a',
  yellow: '#9a9a9a',
  peach: '#9a9a9a',
  maroon: '#9a9a9a',
  red: '#9a9a9a',
  mauve: '#9a9a9a',
  pink: '#9a9a9a',
  flamingo: '#9a9a9a',
  rosewater: '#9a9a9a',
}